import { consumePkceRequest } from './pkce';

const callbackExchanges = new Map<string, Promise<unknown>>();

/** Reuses the same callback exchange across React StrictMode effect replays. */
export const exchangePkceCallbackOnce = <T>(
  code: string,
  state: string,
  exchange: (verifier: string) => Promise<T>,
): Promise<T> => {
  const key = `${code}\u0000${state}`;
  const existing = callbackExchanges.get(key);
  if (existing) return existing as Promise<T>;
  const verifier = consumePkceRequest(state);
  const request = exchange(verifier);
  callbackExchanges.set(key, request);
  return request;
};
